import React, {useEffect, useState, useRef} from 'react';
import './AudioGraph.sass';
import PlayTriangle from '../../../icons/triangle.svg';
import PauseBars from '../../../icons/pause.svg';

const AudioGraph = ({data}) => {

    // The number of bars that should be displayed
    const intTimeout = 50;
    const numBars = 30;
    const minHeight = 3;
    const audioRef = useRef(null);
    const visualizer = useRef(null);
    const [audioContext, setAudioContext] = useState(new AudioContext())
    const [audioSource, setAudioSource] = useState(null);
    const [analyzer, setAnalyzer] = useState(null);
    const [paused, setPaused] = useState(true);
    const [ended, setEnded] = useState(false);
    const [count, setCount] = useState(0);
    const [intervalId, setIntervalId] = useState(0);
    const [dimensions, setDimensions] = useState(null);


    useEffect(() => {
        setAudioSource(audioContext.createMediaElementSource(audioRef.current));
        setAnalyzer(audioContext.createAnalyser());
        let el = document.querySelector(".AudioGraph");
        let w = ((data.style && data.style.width) ? parseInt(data.style.width) : parseInt(el.style.width)) - (el.style.padding * 2);
        let h = ((data.style && data.style.height) ? parseInt(data.style.height) : parseInt(el.style.height)) - el.style.padding * 2;
        setDimensions({"width": w, "height": h});
        return () => {
            clearInterval(intervalId)
        }

    }, []);

    const toggleAudio = () => {
        console.log("AudioGraph toggleAudio()");
        if (paused) {
            audioRef.current.play();
            setEnded(false);
            setPaused(false);
            const newIntervalId = setInterval(() => {
                setCount(prevCount => prevCount + 1);
            }, intTimeout);
            setIntervalId(newIntervalId);
        } else {
            audioRef.current.pause();
            setPaused(true);
            clearInterval(intervalId);
            setIntervalId(0);
            return;
        }
    }

    useEffect(() => {
        if (audioSource) {
            audioSource.connect(analyzer);
            audioSource.connect(audioContext.destination);
        }
    }, [audioSource]);


    const audioEnded = () => {
        toggleAudio();
        setEnded(true);
    }

    const getBars = () => {
        //console.log("AudioGraph getBars()");
        let arr;
        if (analyzer) {
            arr = new Uint8Array(analyzer.frequencyBinCount);
            analyzer.getByteFrequencyData(arr);
        }
        let bars = [];
        let w = dimensions ? (dimensions.width / numBars) : 250 / numBars;
        for (let i = 0; i < numBars; i++) {
            let h = minHeight;
            if (arr && !ended) {
                let pct = arr[i] / 255;
                h = Math.max(minHeight,dimensions.height * pct);
            }
            bars.push(
                <div className="audiograph-visualizer bar"
                     style={{
                         width: w,
                         height: h,
                         transition: ended ? "0.5s" : "none"
                     }}/>
            )
        }

        return bars;
    }

    return (
        <div className={"AudioGraph"}>
            <div className="audiograph-button-wrapper"
                 onClick={toggleAudio}>
                <div className={"audiograph-toggle-button"+((paused&&!(ended||count===0))?" paused":"")} style={
                    {"visibility":(paused?"visible":"hidden")}
                }>
                    <img src={PlayTriangle}/>
                </div>
            </div>
            <div ref={visualizer}
                 className={"audiograph-visualizer"}
                 style={data.style ? data.style : {}}>
                {getBars()}
                <div className={"divider "+((ended||count===0)?"paused":"")}/>
            </div>
            <audio ref={audioRef}
                   src={data.url}
                   onEnded={audioEnded}></audio>
        </div>
    );
};

export default AudioGraph;